module.exports = __webpack_public_path__ + "20250721160708/img/exam.9a32ffc4.png";